<template>
    <div class="allReadList">
        <div class="markHeader">
            <span class="paperName">{{examname}}</span>
            <div>
                <el-select v-model="statusValue" placeholder="全部状态" style="width: 150px">
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                               :value="item.value"></el-option>
                </el-select>
                <el-input placeholder="请输入参与人关键词" v-model="searchName" style="width: 200px"></el-input>
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
        </div>
        <div>
            <el-table :data="tableData">
                <el-table-column label="参与人名称" width="150" class-name="title">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img :src="scope.row.headimageurl?scope.row.headimageurl:require('@/common/images/user.png')">
                            <div>{{ scope.row.customername}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="examtotalscore" label="成绩" class-name="center"></el-table-column>
                <el-table-column prop="submittime" label="提交时间" class-name="center"></el-table-column>
                <el-table-column label="状态" class-name="center">
                    <template slot-scope="scope">
                        <div class="imgStatus">
                            <span v-if="scope.row.ischeckover === 0" style="color: #909399">未批阅</span>
                            <span v-if="scope.row.ischeckover === 1" style="color: #67C23A">已批阅</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="批阅人" class-name="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.checkusername?scope.row.checkusername:'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" label-class-name="tr" width="82">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="jumpDet(scope.row)">{{scope.row.ischeckover===0?'批阅':'查看'}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </div>
    </div>
</template>
<script>
    import {readExampaper} from 'api/testPaperApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    export default {
        name: "allRead",
        // let paperName = this.$router.params.name;
        data() {
            return {
                examname:'',
                tableData: [],
                total: 0,
                searchName: '', //搜索用户
                statusList: [
                    {
                        label: '全部状态',
                        value: ''
                    },
                    {
                        label: '未批阅',
                        value: '0'
                    },
                    {
                        label: '已批阅',
                        value: '10'
                    },
                ],
                statusValue: '',
            }
        },
        mounted() {
            this.allList();
        },
        methods: {
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            allList() {
                readExampaper({
                    data: {
                        // innerid: this.$route.query.id,
                        innerid: this.$route.query.id?this.$route.query.id:'R2ZJdmgUlz2gfuKO',
                        page: 1,
                        pageSize: 10
                    },
                    success: data => {
                        this.setLoading(false);
                        this.examname=data.data.examname;
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                        this.$emit('getNum',this.tableData.length)
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            searchClick() {
                this.setLoading(true);
                let params = {
                    innerid: this.$route.query.id,
                    customername: this.searchName,
                    ischeckover:this.statusValue,
                };
                readExampaper({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 跳转至详情
            jumpDet(row){
                if(row.ischeckover===0){
                    this.$router.push({name: 'MarkingDetails',query: {pageType: 1,id:row.innerid}})
                }else{
                    this.$router.push({name: 'MarkingDetails',query: {pageType: 0,id:row.innerid}})
                }
            },
            ...mapActions([
                'setLoading',
                'setPage'
            ])
        },
        components: {
            Loading,
            Page
        },
        computed: {
            name () {
                return this.$route.query.name
            },
            ...mapGetters([
                'page',
            ])
        },
    }
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .TestpaperMarking {
        .el-tabs__header {
            margin: 0 0 0;
        }
        .markHeader {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 20px 0 20px 0;
            .paperName {
                font-size: 16px;
                color: #333;
            }
            .el-input__inner, .el-input, .el-select {
                margin-right: 20px;
                height: 36px;
            }
        }
        .imageText {
            display: flex;
            align-items: center;
            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-right: 12px;
            }
        }
    }

    .TestpaperMarking .center {
        text-align: center;
    }
</style>
